// BOMB POT TIME: a classic fused bomb whose wick burns down (the flame rides the fuse and the fuse shortens behind it)
// beside the lettering. Pure SVG + CSS, so it scales with the table and needs no asset download.
const W = 420;
const H = 210;

export const BombPotBurst = ({ width = 380, testId = "bomb-pot-burst" }) => (
  <svg data-testid={testId} viewBox={`0 0 ${W} ${H}`} width={width} height={(width * H) / W} overflow="visible" aria-label="Bomb pot time" role="img">
    <defs>
      <radialGradient id="bp-bomb" cx="34%" cy="28%" r="78%">
        <stop offset="0%" stopColor="#6b7483" />
        <stop offset="55%" stopColor="#1a1e25" />
        <stop offset="100%" stopColor="#000" />
      </radialGradient>
      <radialGradient id="bp-flame" cx="50%" cy="55%" r="50%">
        <stop offset="0%" stopColor="#fffdf0" />
        <stop offset="40%" stopColor="#ffd23f" />
        <stop offset="100%" stopColor="rgba(226,70,28,0)" />
      </radialGradient>
      <filter id="bp-glow" x="-120%" y="-120%" width="340%" height="340%">
        <feGaussianBlur stdDeviation="5" result="b" />
        <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
      </filter>
      {/* the wick: the flame travels this exact path, and the unburnt length is trimmed from its tip */}
      <path id="bp-fuse" d="M104 74 C 108 34, 140 20, 176 34" />
    </defs>

    {/* bomb body */}
    <g>
      <ellipse cx="112" cy="188" rx="62" ry="10" fill="#000" opacity="0.45" />
      <circle cx="104" cy="132" r="54" fill="url(#bp-bomb)" stroke="#000" strokeWidth="3" />
      <ellipse cx="82" cy="110" rx="17" ry="10" fill="#fff" opacity="0.26" transform="rotate(-32 82 110)" />
      <ellipse cx="122" cy="160" rx="22" ry="12" fill="#f7b733" opacity="0.1" />
      <rect x="92" y="74" width="24" height="16" rx="4" fill="#32383f" stroke="#000" strokeWidth="2.5" />
      <rect x="88" y="86" width="32" height="7" rx="3" fill="#20252b" stroke="#000" strokeWidth="2" />
    </g>

    {/* unburnt wick — trimmed back toward the bomb as it burns */}
    <use href="#bp-fuse" className="bomb-fuse" pathLength="100" fill="none" stroke="#3b2a12" strokeWidth="8" strokeLinecap="round" strokeDasharray="100" opacity="0.7" />
    <use href="#bp-fuse" className="bomb-fuse" pathLength="100" fill="none" stroke="#c9a15b" strokeWidth="5" strokeLinecap="round" strokeDasharray="100" />

    {/* the flame rides the wick from the tip back down to the bomb */}
    <g filter="url(#bp-glow)">
      <animateMotion dur="3s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear">
        <mpath href="#bp-fuse" />
      </animateMotion>
      <g className="bomb-flame">
        <circle cx="0" cy="0" r="17" fill="url(#bp-flame)" opacity="0.9" />
        <path d="M0 -22 C 9 -10, 11 -4, 8 2 C 5 8, -5 8, -8 2 C -11 -4, -8 -11, 0 -22 Z" fill="#ffb627" />
        <path d="M0 -13 C 5 -6, 5 -1, 3 2 C 1 5, -3 5, -4 2 C -6 -2, -4 -7, 0 -13 Z" fill="#fffbe6" />
      </g>
      <circle className="bomb-ember bomb-ember-a" cx="0" cy="0" r="2.6" fill="#ffd23f" />
      <circle className="bomb-ember bomb-ember-b" cx="0" cy="0" r="2" fill="#ff9c2b" />
      <circle className="bomb-ember bomb-ember-c" cx="0" cy="0" r="1.6" fill="#fff3bf" />
    </g>

    {/* lettering */}
    <g className="bombpot-text" fontFamily="'Unbounded', sans-serif" fontWeight="900" textAnchor="middle">
      <text x="278" y="118" fontSize="42" fill="#2a0a04" stroke="#2a0a04" strokeWidth="10" strokeLinejoin="round">BOMB POT</text>
      <text x="278" y="118" fontSize="42" fill="#fff4c2">BOMB POT</text>
      <text x="278" y="166" fontSize="40" fill="#2a0a04" stroke="#2a0a04" strokeWidth="10" strokeLinejoin="round" letterSpacing="12">TIME</text>
      <text x="278" y="166" fontSize="40" fill="#ffd23f" letterSpacing="12">TIME</text>
    </g>
  </svg>
);
